import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsBrandingRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsBrandingRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { navigation } from './common/constants.tsx';
import { helpCenterSettingBrandingAppPageEntryPoint } from './ui/branding/index.tsx';

export const helpCenterSettingsBrandingRouteEntry = createEntry(
	helpCenterSettingsBrandingRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.branding',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint() {
			if (fg('jcs-global-branding')) {
				return helpCenterSettingBrandingAppPageEntryPoint;
			}
			return undefined;
		},

		resources: [...getServiceDeskSettingsResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsBrandingRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsBrandingRouteEntry',
			},

			enabled: true,
		},
	}),
);
